import { createTheme, createDarkTheme, lightThemePrimitives, darkThemePrimitives } from 'baseui';

const bluePrimitives = {
  primary50:  '#EBF2FD',
  primary100: '#D0E4FA',
  primary200: '#B0CFF6',
  primary300: '#88B8F2',
  primary400: '#76AAEE',
  primary500: '#6AA2EC',
  primary600: '#4B8EE8',
  primary700: '#2E6AC4',
};

const baseLight = createTheme({ ...lightThemePrimitives, ...bluePrimitives });
export const lightTheme = {
  ...baseLight,
  colors: {
    ...baseLight.colors,
    backgroundPrimary: '#C5BFA8',
    backgroundSecondary: '#B8B29A',
    borderOpaque: '#9DAEC0',
    buttonPrimaryFill: '#9DAEC0',
    buttonPrimaryText: '#000000',
    buttonPrimaryHover: '#8EA0B4',
    buttonPrimaryActive: '#7E91A6',
    buttonPrimarySelectedFill: '#9DAEC0',
    buttonPrimarySelectedText: '#000000',
    buttonPrimarySpinnerForeground: '#000000',
    buttonPrimarySpinnerBackground: 'rgba(0,0,0,0.3)',
  },
};

const baseDark = createDarkTheme({ ...darkThemePrimitives, ...bluePrimitives });
export const darkTheme = {
  ...baseDark,
  colors: {
    ...baseDark.colors,
    backgroundPrimary: '#3D5C3A',
    backgroundSecondary: '#2E4A2B',
    borderOpaque: '#EDE6D6',
    buttonPrimaryFill: '#A08860',
    buttonPrimaryText: '#FFFFFF',
    buttonPrimaryHover: '#B49870',
    buttonPrimaryActive: '#8E7850',
    buttonPrimarySelectedFill: '#A08860',
    buttonPrimarySelectedText: '#FFFFFF',
    buttonPrimarySpinnerForeground: '#FFFFFF',
    buttonPrimarySpinnerBackground: 'rgba(255,255,255,0.3)',
    buttonSecondaryFill: 'rgba(255,255,255,0.12)',
    buttonSecondaryText: '#FFFFFF',
    buttonSecondaryHover: 'rgba(255,255,255,0.2)',
    buttonSecondaryActive: 'rgba(255,255,255,0.28)',
    buttonSecondarySelectedFill: 'rgba(255,255,255,0.12)',
    buttonSecondarySelectedText: '#FFFFFF',
  },
};
